export const FOOD = [
  {
    order: true,
    id: 1000151,
    title: "BORSCH (Украинский борщ) ",
    img: "ukrainian-borscht-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 19,

    column: [
      "Состав: картофель (48%), лук репчатый (13%), говяжье мясо (10%), свекла (8%), помидоры (8%), морковь (8%), капуста (3%), приправы.",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 11100152,
    title: "BORSCH VEGAN (Украинский борщ, вегетарианский) ",
    img: "ukrainian-borscht-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 16,
    column: [
      "Состав: картофель (48%), лук (13%), соевое мясо (10%), свекла (8%), помидоры (8%), морковь (8%), капуста (3%), приправы",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 10001526,
    title: "TOMATO SOUP (Томатный суп, мясной) ",
    img: "tomato-soup-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 19,
    column: [
      "Состав: картофель (40%), свинина (20%), помидоры (15%), лапша (10%), морковь (5%), лук (5%), пармезан (2%), приправы.",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 1000152,
    title: "TOMATO SOUP (Томатный суп, вегетарианский) ",
    img: "tomato-soup-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 16,
    column: [
      "Состав: картофель (40%), соевое мясо (20%), помидоры (15%), лапша (10%), морковь (5%), лук (5%), пармезан (2%), приправы. ",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 1000153,
    title: "BUCKWHEAT (Гречка) ",
    img: "buckwheat-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 23,
    column: [
      "Состав: гречневая крупа (57%), мясо свинины (26%), помидоры (5%), лук (5%), морковь (5%), приправы",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 1000154,
    title: "BUCKWHEAT VEGAN (Гречка вегетарианская) ",
    img: "buckwheat-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 20,
    column: [
      "Состав: гречневая крупа (57%), соевое мясо (26%), помидоры (5%), лук (5%), морковь (5%), приправы.",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 1000155,
    title: "RIZOTTO (Ризотто) ",
    img: "rizotto-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 23,

    column: [
      "Состав: рис (57%), куриное мясо (23%), шампиньоны (6%), лук (5%), морковь (5%), приправы",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 1000156,
    title: "BUCKWHEAT VEGAN (Ризотто вегетарианская) ",
    img: "rizotto-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 20,

    column: [
      "Состав: рис (57%), соевое мясо (23%), шампиньоны (6%), лук (5%), морковь (5%), приправы",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 1000157,
    title: "CREAMY POTATO (Сливочный картофель) ",
    img: "creamy-potato-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 23,
    column: [
      "Состав: картофель (50%), куриное мясо (20%), сухое молоко (10%), лук репчатый (10%), шампиньоны (5%), пармезан (2%), приправы",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  //   {
  //     order: true,
  //     id: 1000158,
  //     title: "CREAMY POTATO VEGAN (Сливочный картофель, вегетарианский) ",
  //     img: "creamy-potato-front.png",
  //     desc: "Max pack +50%",
  //     category: "lazy_snark",
  //     price: 18,
  //     column: [
  //       "Высококаллорийные блюда быстрого приготовления",
  //       "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
  //       "- сохранены витамины и микроэлементы",
  //       "- лучшее усвоение и долгое ощущение сытости ",
  //       "- легкий вес и компактность упаковки",
  //       "- срок годности 6 месяцев",
  //       `Инструкция по приготовлению:
  //           -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
  //           -закрыть пакет и подождать 10 минут
  //           -перемешать содежимое и оставить еще на 5 минут
  //           -готово, приятного аппетита!`,
  //       "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
  //       "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
  //     ],
  //   },
  {
    order: true,
    id: 1000159,
    title: "PASTA BOLOGNESE (Паста болоньезе) ",
    img: "pasta-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 23,
    column: [
      "Состав:лапша (72%), куриное мясо (20%), помидоры (5%), пармезан (2%), приправы",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 1000160,
    title: "PASTA BOLOGNESE VEGAN (Паста болоньезе, вегетарианская) ",
    img: "pasta-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 20,
    column: [
      "Состав: лапша (72%), соевое мясо (20%), помидоры (5%), пармезан (2%), приправы.",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 10009161,
    title: "LOBIO (Лобио) ",
    img: "lobio-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 23,
    column: [
      "Состав: фасоль в томатном соусе (54%), мясо свинины (27%), картофель (11%), лук (11%), приправы",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 1000161,
    title: "LOBIO (Лобио, вегетарианский) ",
    img: "lobio-front.png",
    desc: "lobio-front.png",
    category: "lazy_snark",
    price: 19,
    column: [
      "Состав: фасоль в томатном соусе (54%), соевое мясо (27%), картофель (11%), лук (11%), приправы",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 1000162,
    title: "BULGUR WITH CORN (Булгур с кукурузой) ",
    img: "bulgur-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 23,
    column: [
      "Состав: булгур (63%), куриное мясо (21%), морковь (5%), кукуруза (5%), лук (3%), приправы",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 1000163,
    title: "BULGUR WITH CORN VEGAN (Булгур с кукурузой, вегетарианский) ",
    img: "bulgur-front.png",
    desc: "Max pack +50%",
    category: "lazy_snark",
    price: 20,
    column: [
      "Состав: булгур (63%), соевое мясо (21%), морковь (5%), кукуруза (5%), лук (3%), приправы",
      "Высококаллорийные блюда быстрого приготовления",
      "-только из натуральных ингредиентов: без ГМО, химических добавок и консервантов",
      "- сохранены витамины и микроэлементы",
      "- лучшее усвоение и долгое ощущение сытости ",
      "- легкий вес и компактность упаковки",
      "- срок годности 6 месяцев",
      `Инструкция по приготовлению:
          -открыть пакет, добавить кипяток (см. инструкцию на упаковке), перемешать
          -закрыть пакет и подождать 10 минут
          -перемешать содежимое и оставить еще на 5 минут
          -готово, приятного аппетита!`,
      "Если на улице холодно,  поместите пакет в теплое место: в карман, под куртку, в спальный мешок или рюкзак - так вода не остынет быстрее чем приготовится еда",
      "В продукте уже присутствуют специи, однако вы можете добавить их по вкусу",
    ],
  },
  {
    order: true,
    id: 1000164,
    title: "JERKY BEET (Вяленая говядина)",
    img: "jerky-beef-front.png",
    desc: "60 грамм",
    category: "lazy_snark",
    price: 18,
    column: [
      "Ингредиенты: мясо говядины, маринад (соевый соус, винный уксус, чеснок, сахар, перец чили, имбирь, соль)",
      "Пищевая ценность: 205,8 калорий.",
      "Вес: 60 грамм",
    ],
  },
  //   {
  //     order: true,
  //     id: 100016498,
  //     title: "JERKY chicken (Вяленая курица)",
  //     img: "jerky-chicken-front.png",
  //     desc: "",
  //     category: "lazy_snark",
  //     price: 15,
  //     column: [
  //       "Ингредиенты: куриное мясо, маринад (соевый соус, винный уксус, мед, французская горчица, сахар, перец чили, имбирь, оливковое масло, соль)",
  //       "Пищевая ценность:  217,8 калорий.",
  //       "Вес: 60 грамм",
  //     ],
  //   },
  {
    order: true,
    id: 10030164980,
    title: "Granola Chocolate with bananes (Гранола)",
    img: "chocolate-granola-front.png",
    desc: "шоколадная",
    category: "lazy_snark",
    price: 12,
    column: [
      "Ингредиенты: овсянка печеная, бананы, фундук, миндаль, изюм, какао, масло сливочное, мед, молоко сухое (20 грамм).",
      "Добавьте ~300 мл кипяченой воды. Подождите всего 10-15 минут.",
    ],
  },
  {
    order: true,
    id: 10400164980,
    title: "Granola Apple + Banana (Гранола яблоко+банан)",
    img: "chocolate-granola-front.png",
    desc: "яблоко+банан",
    category: "lazy_snark",
    price: 12,
    column: [
      "Ингредиенты: овсяная каша, яблоки, бананы, смола, семечки (тыквенные, подсолнечные), орехи (миндаль, фундук, грецкий орех), яблочный сок, мед, корица, сухое молоко (20 грамм).",
      "Добавьте ~300 мл кипяченой воды. Подождите всего 10-15 минут.",
    ],
  },
  {
    order: true,
    id: 10900164980,
    title: "Granola Orange (Гранола)",
    img: "chocolate-granola-front.png",
    desc: "апельсиновая",
    category: "lazy_snark",
    price: 12,
    column: [
      "Ингредиенты: овсяная каша, миндаль, кешью, изюм, курага, мед, апельсиново-лимонный сок, сухое молоко (20 г).",
      "Добавьте ~300 мл кипяченой воды. Подождите всего 10-15 минут.",
    ],
  },
  {
    order: true,
    id: 10600164909009,
    title: "Украинский борщ веган",
    img: "Izy__Meal-Borscht-Web-Thumbnail.jpg",
    desc: "Borscht",
    category: "sublimates",
    price: 16,
    column: [
      "Украинский сублимированный борщ - это простая версия классического супа, приготовленного из свеклы, моркови, картофеля и капусты, без добавления укропа. Он не содержит искусственных добавок, что обеспечивает натуральные и питательные вкусовые качества. Этот суп - отличный источник витаминов и минералов, что делает его полезным блюдом. Для приготовления требуется всего лишь добавить воды, что позволяет быстро и просто насладиться теплым и приятным блюдом на свежем воздухе.",
    ],
  },
  {
    order: true,
    id: 1000164983409,
    title: "Тыквенный суп веганский",
    img: "23.56.48.jpg",
    desc: "Pumpkin soup",
    category: "izy",
    price: 16,
    column: [],
  },

  {
    order: true,
    id: 1000164982109,
    title: "Лобио веган",
    img: "23.51.25.jpg",
    desc: "Mashed Beans with herbs",
    category: "izy",
    price: 17,
    column: [
      "Лобио - это простая смесь фасоли и овощного ассорти, приправленная различными травами для придания вкуса. Это сублимированное блюдо, не содержащее искусственных ингредиентов, которое является полезным и питательным блюдом с высоким содержанием витаминов и минералов. Чтобы приготовить, просто добавьте горячей воды, перемешайте и подождите, пока жидкость восстановится, как при заваривании чая. Он разработан с учетом простоты приготовления, что делает его подходящим для активного отдыха, где возможности приготовления ограничены.",
    ],
  },
  {
    order: true,
    id: 10001649821098,
    title: "Пюре сулугуни вегетарианское",
    img: "Izy__Meal-Puree-Web-Thumbnail.jpg",
    desc: "Puree with smoked sulguni",
    category: "izy",
    price: 17,
    column: [
      "Это сублимированное блюдо сочетает в себе мягкость и неповторимый аромат копченого сыра сулугуни, а для придания вкуса оно приправлено укропом. Оно готовится без использования искусственных ингредиентов, чтобы сделать блюдо одновременно вкусным и питательным. Приготовление очень простое: добавьте горячую воду и подождите несколько минут, пока блюдо не впитает влагу. Этот продукт идеально подходит для тех, кто ищет быстрое, полезное блюдо с неповторимым вкусом, подходящее для трапезы на свежем воздухе.",
    ],
  },
  {
    order: true,
    id: 10001649836409,
    title: "Харчо",
    img: "23.41.04.jpg",
    desc: "Chiken soup kharcho",
    category: "izy",
    price: 24,
    column: [],
  },
  {
    order: true,
    id: 10300164982109817,
    title: "Cублимированные абрикос",
    img: "67441f06af0f7ef9e0d09955_Izy__Apricots-small.png",
    desc: "Apricots",
    category: "izy",
    price: 10,
    column: [],
  },
  {
    order: true,
    id: 10001649821098136,
    title: "Cублимированные клубника",
    img: "6748c170457a94e8c61a30dd_Izy__Strawberries-small.png",
    desc: "Strawberries",
    category: "izy",
    price: 10,
    column: [],
  },
  {
    order: true,
    id: 109001649821098135,
    title: "Cублимированные дыня",
    img: "6748c0134409e73d369a01fe_Izy__Cantaloupe-smal.png",
    desc: "Cantaloupes",
    category: "izy",
    price: 10,
    column: [],
  },
  {
    order: true,
    id: 100201649821098134,
    title: "Cублимированные фейхоа",
    img: "6748bd0b3865454921878fcc_Izy__Feijoa-small__Front-min.png",
    desc: "Feijoas",
    category: "izy",
    price: 10,
    column: [],
  },
  {
    order: true,
    id: 100301649821098133,
    title: "Cублимированные персик",
    img: "6748bf97622f36c7b8776249_Izy__Peaches-small.png",
    desc: "Peachs",
    category: "izy",
    price: 10,
    column: [],
  },
  {
    order: true,
    id: 100401649821098132,
    title: "Cублимированные слива",
    img: "6744312e8726e6f95f85b1ad_Izy__Plum-smal.png",
    desc: "Plums",
    category: "izy",
    price: 10,
    column: [],
  },
  {
    order: true,
    id: 10001649821098131,
    title: "Cублимированные инжир",
    img: "6748bda752df4674f7c0b351_Izy__Figs-small.png",
    desc: "Figs",
    category: "izy",
    price: 10,
    column: [],
  },
  //   {
  //     order: true,
  //     id: 1000164982109813,
  //     title: "Cублимированные малина | Raspberry",
  //     img: "6744312e8726e6f95f85b1ad_Izy__Plum-smal.png",
  //     desc: "",
  //     category: "izy",
  //     price: 10,
  //     column: [],
  //   },
  //   {
  //     order: true,
  //     id: 100016498210981,
  //     title: "Cублимированные бананы | Bananas",
  //     img: "Izy-Packaging__Banana-Small.png",
  //     desc: "",
  //     category: "izy",
  //     price: 7,
  //     column: [],
  //   },
  //   {
  //     order: true,
  //     id: 100016498210982,
  //     title: "Cублимированные яблоки | Apples",
  //     img: "Izy-Packaging__Apple-Small.png",
  //     desc: "",
  //     category: "izy",
  //     price: 7,
  //     column: [],
  //   },
  {
    order: true,
    id: 100016498210988,
    title: "Чипсы сулугуни",
    img: "a281_Izy__Smoked-Sulguni-25g-Mockup.png",
    desc: "25 грамм",
    category: "izy",
    price: 7,
    column: [],
  },
  {
    order: true,
    id: 1000164982109889,
    title: "Чипсы сулугуни",
    img: "a281_Izy__Smoked-Sulguni-25g-Mockup.png",
    desc: "90 грамм",
    category: "izy",
    price: 18,
    column: [],
  },
  {
    order: true,
    id: 1000169498210988,
    title: "Кофе Peru",
    img: "coffee-peru-front.png",
    desc: "Lazy Snark",
    category: "coffee",
    price: 6,
    column: ["Грейпфрут, слива, апельсин"],
  },
  {
    order: true,
    id: 10001694982109880,
    title: "Кофе Burundi",
    img: "coffee-burundi-front.png",
    desc: "Lazy Snark",
    category: "coffee",
    price: 6,
    column: ["Клубника, Черника, Карамель"],
  },
  {
    order: true,
    id: 100016949898210988,
    title: "Кофе Rwanda",
    img: "coffee-rwanda-front.png",
    desc: "Lazy Snark",
    category: "coffee",
    price: 6,
    column: ["Апельсин, папайя, киви, цветы"],
  },
  {
    order: true,
    id: 9100016949898210988,
    title: "Tasty кофе Кения Маунт",
    img: "drip-coffee-kenya-maunt-new-768.png",
    desc: "1 дрип",
    category: "coffee",
    price: 4,
    column: ["Сочный кофе с нотами красной смородины, какао и чёрного чая"],
  },
  {
    order: true,
    id: 9100016949887980210988,
    title: "Tasty кофе Бэрри",
    img: "169-Barry_10-768.png",
    desc: "1 дрип",
    category: "coffee",
    price: 4,
    column: [
      "Плотный кофе с нотами ореховой пасты, темных ягод и печенья",
      "идеален для молочных напитков",
    ],
  },
  {
    order: true,
    id: 910001694989802109889,
    title: "Tasty кофе Эфиопия Сидамо",
    img: "drip-coffee-ethiopia-sidamo-new-768.png",
    desc: "1 дрип",
    category: "coffee",
    price: 4,
    column: ["Лёгкий кофе с нотами цветов, желтых фруктов и спелого лимона"],
  },
];
